module.exports = __webpack_public_path__ + "img/bag-1.bd37b990.jpg";